import { CALL_API } from 'redux-api-middleware'
import queryString from 'query-string'
import { getTags, getMarkets, getUseCases, getVerticals } from '../selectors'

const ACCEPT_JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

const headers = {
  ...ACCEPT_JSON_HEADERS,
}

export const SET_AUTH_HEADER = 'SET_AUTH_HEADER'
export const setAuthHeader = auth => ({
  type: SET_AUTH_HEADER,
  meta: auth,
})

export const logout = () => ({
  type: SET_AUTH_HEADER,
  meta: '',
})

export const GET_AUTH_REQUEST = 'GET_AUTH_REQUEST'
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS'
export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE'
export const fetchAuthIfNeeded = () => ({
  [CALL_API]: {
    endpoint: '/account/oauth2/exchange',
    method: 'GET',
    credentials: 'include',
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [GET_AUTH_REQUEST, GET_AUTH_SUCCESS, GET_AUTH_FAILURE],
  },
})

export const GET_OPPORTUNITIES_REQUEST = 'GET_OPPORTUNITIES_REQUEST'
export const GET_OPPORTUNITIES_SUCCESS = 'GET_OPPORTUNITIES_SUCCESS'
export const GET_OPPORTUNITIES_FAILURE = 'GET_OPPORTUNITIES_FAILURE'
export const fetchOpportunites = (
  {
    page = 1,
    rows = 20,
    search,
    organization,
    tags,
    start,
    end,
    ongoing,
    hidden,
    live,
    deleted,
    hasTags,
    tagsModifiedByOrg,
    tagsModifiedBySubmittable,
    tagsModifiedBySubmittableExceptAutoTag,
    tagsModifiedByAutoTagOnly,
  } = {},
) => ({
  [CALL_API]: {
    headers,
    method: 'GET',
    endpoint: `/opportunities/?${queryString.stringify({
      page,
      rows,
      search,
      organization,
      tags,
      start,
      end,
      ongoing,
      hidden,
      live,
      deleted,
      hasTags,
      tagsModifiedByOrg,
      tagsModifiedBySubmittable,
      tagsModifiedBySubmittableExceptAutoTag,
      tagsModifiedByAutoTagOnly,
    })}`,
    types: [
      GET_OPPORTUNITIES_REQUEST,
      {
        type: GET_OPPORTUNITIES_SUCCESS,
        meta: {
          rows,
        },
      },
      GET_OPPORTUNITIES_FAILURE,
    ],
  },
})

export const GET_OPPORTUNITY_REQUEST = 'GET_OPPORTUNITY_REQUEST'
export const GET_OPPORTUNITY_SUCCESS = 'GET_OPPORTUNITY_SUCCESS'
export const GET_OPPORTUNITY_FAILURE = 'GET_OPPORTUNITY_FAILURE'
export const fetchOpportunity = ({ id }) => ({
  [CALL_API]: {
    headers,
    method: 'GET',
    endpoint: `/opportunities/${id}`,
    types: [
      GET_OPPORTUNITY_REQUEST,
      GET_OPPORTUNITY_SUCCESS,
      GET_OPPORTUNITY_FAILURE,
    ],
  },
})

export const GET_CATEGORIES_TAGS_REQUEST = 'GET_CATEGORIES_TAGS_REQUEST'
export const GET_CATEGORIES_TAGS_SUCCESS = 'GET_CATEGORIES_TAGS_SUCCESS'
export const GET_CATEGORIES_TAGS_FAILURE = 'GET_CATEGORIES_TAGS_FAILURE'
export const fetchCategoriesTagsIfNeeded = () => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [
      GET_CATEGORIES_TAGS_REQUEST,
      GET_CATEGORIES_TAGS_SUCCESS,
      GET_CATEGORIES_TAGS_FAILURE,
    ],
    endpoint: '/tags',
    method: 'GET',
    bailout: state => getTags(state).isFetching || getTags(state).items.length,
  },
})

export const PUT_CATEGORY_TAGS_REQUEST = 'PUT_CATEGORY_TAGS_REQUEST'
export const PUT_CATEGORY_TAGS_SUCCESS = 'PUT_CATEGORY_TAGS_SUCCESS'
export const PUT_CATEGORY_TAGS_FAILURE = 'PUT_CATEGORY_TAGS_FAILURE'
export const putCategoryTagsIfNeeded = ({ id, tags }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [
      PUT_CATEGORY_TAGS_REQUEST,
      PUT_CATEGORY_TAGS_SUCCESS,
      PUT_CATEGORY_TAGS_FAILURE,
    ],
    endpoint: `/opportunities/${id}/tags`,
    method: 'PUT',
    body: JSON.stringify(tags),
  },
})

export const GET_MARKETS_REQUEST = 'GET_MARKETS_REQUEST'
export const GET_MARKETS_SUCCESS = 'GET_MARKETS_SUCCESS'
export const GET_MARKETS_FAILURE = 'GET_MARKETS_FAILURE'
export const fetchMarketsIfNeeded = () => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [GET_MARKETS_REQUEST, GET_MARKETS_SUCCESS, GET_MARKETS_FAILURE],
    endpoint: '/organizations/markets',
    method: 'GET',
    bailout: state =>
      getMarkets(state).isFetching || getMarkets(state).items.length,
  },
})

export const PUT_MARKET_REQUEST = 'PUT_MARKET_REQUEST'
export const PUT_MARKET_SUCCESS = 'PUT_MARKET_SUCCESS'
export const PUT_MARKET_FAILURE = 'PUT_MARKET_FAILURE'
export const putMarket = ({ orgId, marketId }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [PUT_MARKET_REQUEST, PUT_MARKET_SUCCESS, PUT_MARKET_FAILURE],
    endpoint: `/organizations/${orgId}/market`,
    method: 'PUT',
    body: JSON.stringify(marketId),
    bailout: state => {
      return marketId === null
    },
  },
})

export const GET_USECASES_REQUEST = 'GET_USECASES_REQUEST'
export const GET_USECASES_SUCCESS = 'GET_USECASES_SUCCESS'
export const GET_USECASES_FAILURE = 'GET_USECASES_FAILURE'
export const fetchUseCasesIfNeeded = () => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [GET_USECASES_REQUEST, GET_USECASES_SUCCESS, GET_USECASES_FAILURE],
    endpoint: '/organizations/usecases',
    method: 'GET',
    bailout: state =>
      getUseCases(state).isFetching || getUseCases(state).items.length,
  },
})

export const PUT_ORG_USE_CASES_REQUEST = 'PUT_ORG_USE_CASES_REQUEST'
export const PUT_ORG_USE_CASES_SUCCESS = 'PUT_ORG_USE_CASES_SUCCESS'
export const PUT_ORG_USE_CASES_FAILURE = 'PUT_ORG_USE_CASES_FAILURE'
export const putOrgUseCases = ({ id, items }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [
      PUT_ORG_USE_CASES_REQUEST,
      PUT_ORG_USE_CASES_SUCCESS,
      PUT_ORG_USE_CASES_FAILURE,
    ],
    endpoint: `/organizations/${id}/usecases`,
    method: 'PUT',
    body: JSON.stringify(items),
  },
})

export const POST_TAGS_REVIEWED_BY_REQUEST = 'POST_TAGS_REVIEWED_BY_REQUEST'
export const POST_TAGS_REVIEWED_BY_SUCCESS = 'POST_TAGS_REVIEWED_BY_SUCCESS'
export const POST_TAGS_REVIEWED_BY_FAILURE = 'POST_TAGS_REVIEWED_BY_FAILURE'
export const postOpportunityTagsReviewed = ({ opportunityId, userEmail }) => ({
  [CALL_API]: {
    types: [
      POST_TAGS_REVIEWED_BY_REQUEST,
      {
        type: POST_TAGS_REVIEWED_BY_SUCCESS,
        meta: { userEmail, reviewedDate: Date.now() },
      },
      POST_TAGS_REVIEWED_BY_FAILURE,
    ],
    endpoint: `/opportunities/${opportunityId}/tagsreviewed`,
    method: 'POST',
  },
})

export const GET_ORG_REQUEST = 'GET_ORG_REQUEST'
export const GET_ORG_SUCCESS = 'GET_ORG_SUCCESS'
export const GET_ORG_FAILURE = 'GET_ORG_FAILURE'
export const fetchOrgIfNeeded = id => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [GET_ORG_REQUEST, GET_ORG_SUCCESS, GET_ORG_FAILURE],
    endpoint: `/organization/${id}`,
    method: 'GET',
  },
})

export const GET_VERTICALS_REQUEST = 'GET_VERTICALS_REQUEST'
export const GET_VERTICALS_SUCCESS = 'GET_VERTICALS_SUCCESS'
export const GET_VERTICALS_FAILURE = 'GET_VERTICALS_FAILURE'
export const fetchVerticalsIfNeeded = () => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [
      GET_VERTICALS_REQUEST,
      GET_VERTICALS_SUCCESS,
      GET_VERTICALS_FAILURE,
    ],
    endpoint: '/verticals',
    method: 'GET',
    bailout: state =>
      getVerticals(state).isFetching || getVerticals(state).items.length,
  },
})

export const PUT_VERTICAL_REQUEST = 'PUT_VERTICAL_REQUEST'
export const PUT_VERTICAL_SUCCESS = 'PUT_VERTICAL_SUCCESS'
export const PUT_VERTICAL_FAILURE = 'PUT_VERTICAL_FAILURE'
export const putVertical = ({ orgId, verticalId, industryId }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [PUT_VERTICAL_REQUEST, PUT_VERTICAL_SUCCESS, PUT_VERTICAL_FAILURE],
    endpoint: `/verticals/${orgId}/`,
    method: 'POST',
    body: JSON.stringify({ verticalId, industryId }),
    bailout: state => {
      return verticalId === null || orgId === null
    },
  },
})

export const POST_NEW_VIP_REQUEST = 'POST_NEW_VIP_REQUEST'
export const POST_NEW_VIP_SUCCESS = 'POST_NEW_VIP_SUCCESS'
export const POST_NEW_VIP_FAILURE = 'POST_NEW_VIP_FAILURE'
export const postNewVip = ({ ...body }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [POST_NEW_VIP_REQUEST, POST_NEW_VIP_SUCCESS, POST_NEW_VIP_FAILURE],
    endpoint: `/vip/add`,
    method: 'POST',
    body: JSON.stringify(body)
  },
})

export const POST_VIP_CONVERT_REQUEST = 'POST_VIP_CONVERT_REQUEST'
export const POST_VIP_CONVERT_SUCCESS = 'POST_VIP_CONVERT_SUCCESS'
export const POST_VIP_CONVERT_FAILURE = 'POST_VIP_CONVERT_FAILURE'
export const postVipConvert = ({ ...body }) => ({
  [CALL_API]: {
    headers: {
      ...ACCEPT_JSON_HEADERS,
    },
    types: [POST_VIP_CONVERT_REQUEST, POST_VIP_CONVERT_SUCCESS, POST_VIP_CONVERT_FAILURE],
    endpoint: `/vip/convert`,
    method: 'POST',
    body: JSON.stringify(body)
  },
})



// WEBPACK FOOTER //
// ./src/actions/index.js